import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

import {
  LeadCaptureService,
  LeadCaptureState,
  LeadIntent
} from '../lead-capture/lead-capture.service';

@Component({
  selector: 'app-development-notice',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './development-notice.component.html',
  styleUrl: './development-notice.component.scss'
})
export class DevelopmentNoticeComponent implements OnInit, OnDestroy {
  private readonly leadCaptureService = inject(LeadCaptureService);
  private subscription?: Subscription;
  private closeTimer?: ReturnType<typeof setTimeout>;

  protected state: LeadCaptureState = {
    isOpen: false,
    intent: 'beta',
    source: 'first-visit'
  };

  protected email = '';
  protected feedbackMessage = '';
  protected isSuccess = false;

  ngOnInit(): void {
    this.subscription = this.leadCaptureService.state$.subscribe(state => {
      this.state = state;

      if (state.isOpen) {
        this.feedbackMessage = '';
        this.isSuccess = false;
      }
    });

    setTimeout(() => {
      this.leadCaptureService.showFirstVisitNotice();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();

    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
    }
  }

  protected close(): void {
    this.leadCaptureService.close();
  }

  protected async submit(intent: LeadIntent): Promise<void> {
    const result = await this.leadCaptureService.submit(this.email, intent);

    this.feedbackMessage = result.message;
    this.isSuccess = result.success;

    if (result.success) {
      this.email = '';

      this.closeTimer = setTimeout(() => {
        this.leadCaptureService.close();
      }, 1300);
    }
  }
}
